<template>
    <div>
        <h1 class="display-heading">Doctor List</h1>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col width="250">
                    <col>
                    <col>
                    <col width="100">
                    <col width="100">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Join Date</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email Address</th>
                            <th scope="col">Status</th>
                            <th scope="col">Approval</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="doctorList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(doctor, index) in doctorList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>{{doctor.joinedDate}}</td>
                            <td>{{doctor.name}}</td>
                            <td>{{doctor.email}}</td>
                            <td>
                                <span class="badge text-nowrap" :class="{
                                    'badge-success': doctor.isReviewed,
                                    'badge-secondary': !doctor.isReviewed,
                                }">
                                    {{doctor.isReviewed ? 'Reviewed' : 'Not Review Yet'}}
                                </span>
                            </td>
                            <td>
                                <template v-if="doctor.isReviewed">
                                    <span class="badge text-nowrap" :class="{
                                        'badge-success': doctor.isApproved && !doctor.isDisapproved,
                                        'badge-danger': doctor.isDisapproved,
                                    }">
                                        {{(doctor.isApproved && !doctor.isDisapproved) ? 'Approved' : 'Disapproved'}}
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-secondary text-nowrap">
                                        Not Review Yet
                                    </span>
                                </template>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'superadmin-doctor-approval',
                                    'params': {'id': doctor.doctorId}
                                }">
                                Review Doctor
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getDoctors();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'doctorList': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getDoctors();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getDoctors () {
            this.axios.post('doctor/GetAllDoctors', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.doctorList = list.map((doctor) => ({
                    'isReviewed': doctor.ir,
                    'isApproved': doctor.ia && !doctor.id,
                    'isDisapproved': doctor.id,
                    'name': doctor.n ? doctor.n : '-',
                    'email': doctor.e ? doctor.e : '-',
                    'joinedDate': doctor.jd ? convertToUserReadableDateTime(doctor.jd) : '-',
                    'doctorId': doctor.i
                }));
            });
        }
    }
};

</script>

<style>

</style>
